package io.horion.cv.pages.cv

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.components.DownloadCvButton
import io.horion.cv.components.PersonalizedSectionButton
import io.horion.cv.components.preview.CvPreviewPanel
import io.horion.cv.components.preview.FormContent
import io.horion.cv.components.widgets.InfoBox
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.di.koinGet
import io.horion.cv.models.defaultTitleFor
import io.horion.cv.models.ExtraSection
import io.horion.cv.models.createPersonalizedSection
import io.horion.cv.models.extraSectionsCatalog
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.AccordionRowStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.dom.Style
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.size
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Input
import io.horion.cv.styles.ViewButtonStyle
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.components.icons.fa.FaCloudflare
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import io.horion.cv.api.datasource.cv.Section
import io.horion.cv.components.widgets.ToastType
import io.horion.cv.components.widgets.AlertMessage
import io.horion.cv.models.PersonalizedSectionType
import io.horion.cv.styles.AccordionActionButtonBoxStyle
import io.horion.cv.styles.AccordionArrowIconStyle
import io.horion.cv.styles.AccordionContainerStyle
import io.horion.cv.styles.AccordionPlusIconStyle
import io.horion.cv.styles.AccordionPlusIconStyles
import io.horion.cv.styles.AccordionTitleStyle
import io.horion.cv.styles.ExtraSectionsGridStyle
import io.horion.cv.styles.FormActionButtonStyle
import io.horion.cv.styles.FormActionGridContainerStyle
import io.horion.cv.styles.FormActionSectionStyle
import io.horion.cv.styles.FormActionSubmitRowStyle
import io.horion.cv.styles.HeadbarBackButtonStyle
import io.horion.cv.styles.HeadbarContainerStyle
import io.horion.cv.styles.HeadbarDownloadWrapperStyle
import io.horion.cv.styles.HeadbarIconSizeStyle
import io.horion.cv.styles.HeadbarTextSizeStyle
import io.horion.cv.styles.HeadbarThemeIconSizeStyle
import io.horion.cv.styles.HeadbarThemeToggleGroupStyle
import io.horion.cv.styles.HeadbarTitleGroupStyle
import io.horion.cv.styles.HeadbarTitleInputStyle
import io.horion.cv.styles.HeadbarTitleStyle
import io.horion.cv.styles.InfoDividerStyle
import io.horion.cv.styles.InfoFormScrollContainerStyle
import io.horion.cv.styles.InfoMainLayoutContainerStyle
import io.horion.cv.styles.InfoPreviewContainerStyle
import io.horion.cv.styles.ReAccordionActionIconStyle
import io.horion.cv.styles.ReAccordionPlusIconStyle
import io.horion.cv.styles.ReAccordionPlusIconStyles
import io.horion.cv.styles.SeparatorStyle
import kotlinx.browser.window
import org.w3c.dom.HTMLInputElement

@Page("/info_pers")
@Composable
fun InfoPage() {
    val cvViewModel = koinGet<CvViewModel>()

    var openedSectionId by remember {
        mutableStateOf<String?>(null)
    }

    var activeExtraSections by remember {
        mutableStateOf<List<ExtraSection>>(emptyList())
    }

    var createError by remember {
        mutableStateOf<String?>(null)
    }

    LaunchedEffect(cvViewModel.cvUiState.error) {
        cvViewModel.cvUiState.error?.let {
            createError = it
        }
    }


    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    fun updateSectionTitle(
        sectionId: String,
        newTitle: String
    ) {
        activeExtraSections = activeExtraSections.map { section ->
            if (section.id == sectionId) {
                section.copy(title = newTitle)
            } else {
                section
            }
        }
    }

    AlertMessage(
        message = createError.orEmpty(),
        isVisible = createError != null,
        type = ToastType.ERROR,
        onDismiss = {
            createError = null
        }
    )

//    LaunchedEffect(Unit) {
//        cvViewModel.resetToBlank()
//    }


    Style {
        """
        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(-8px);
            }

            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @keyframes popUp {
            from {
                opacity: 0;
                transform: translateY(10px) scale(0.97);
            }

            to {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }
        """.trimIndent()
    }

    Div(
        attrs = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("height", "100vh")
                property("max-height", "100vh")
                property("overflow", "hidden")
                property(
                    "background-color",
                    if (isDark) {
                        Colors.DarkBG.toString()
                    } else {
                        Colors.White.toString()
                    }
                )
                property("transition", "background-color 300ms ease")
            }
            .toAttrs()
    ) {
        Headbar(
            cvViewModel = cvViewModel
        )

        Div(
            attrs = InfoMainLayoutContainerStyle
                .toModifier()
                .toAttrs()
        ) {
            Div(
                attrs = InfoFormScrollContainerStyle
                    .toModifier()
                    .toAttrs()
            ) {
                FormContent(
                    cvViewModel = cvViewModel,
                    openedSectionId = openedSectionId,
                    activeExtraSections = activeExtraSections,

                    onSectionOpen = {
                        openedSectionId = it
                    },

                    onAddExtraSection = { extraSection ->
                        activeExtraSections =
                            activeExtraSections + extraSection

                        openedSectionId = extraSection.id
                    },
                    onOpenExtraSection = { extraSection ->
                        openedSectionId = extraSection.id
                    },
                    onRenameSection = { id, title ->
                        updateSectionTitle(id, title)
                    }
                )
            }

            Div(
                attrs = InfoDividerStyle
                    .toModifier()
                    .toAttrs()
            )

            Div(
                attrs = InfoPreviewContainerStyle
                    .toModifier()
                    .toAttrs()
            ) {
                CvPreviewPanel(
                    data = cvViewModel.cvUiState.data,
                    cvViewModel = cvViewModel,
                    model = cvViewModel.cvUiState.model
                )
            }
        }
    }
}


@Composable
fun Separator(
    modifier: Modifier = Modifier
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Box(
        modifier = SeparatorStyle.toModifier()
            .fillMaxWidth()
            .then(modifier)
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(if (isDark) Colors.holder else Colors.LightGray)
        )
    }
}

@Composable
fun AccordionRow(
    title: String,
    isOpen: Boolean,
    onClick: () -> Unit,
    onRename: (String) -> Unit,
    modifier: Modifier = Modifier,
) {

    var isDropdownOpen by remember { mutableStateOf(false) }
    var selectedMenuOption by remember { mutableStateOf<String?>("personal-info") }
    var triggerBottomPx by remember { mutableStateOf(0.0) }
    var isEditing by remember { mutableStateOf(false) }

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val titleColor = if (isOpen) (if (isDark) Colors.White else Colors.Primary) else Colors.Placeholder

    Column(
        modifier = AccordionContainerStyle.toModifier()
            .fillMaxWidth()
            .then(modifier)
    ) {
        Box(
            modifier = AccordionRowStyle.toModifier()
                .fillMaxWidth()
                .cursor(Cursor.Pointer)
                .onClick { onClick() }
                .position(Position.Relative),
            contentAlignment = Alignment.CenterStart
        ) {
            Row(
                modifier = Modifier.padding(topBottom = 40.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (isEditing) {
                    TextFormField(
                        label = "",
                        value = title,
                        onValueChange = { onRename(it) },
                        modifier = Modifier.width(200.px),
                    )
                } else {
                    SpanText(
                        title,
                        modifier = AccordionTitleStyle.toModifier()
                            .color(titleColor)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.SemiBold)
                            .whiteSpace(WhiteSpace.NoWrap)
                            .onClick { isEditing = true }
                    )
                }
            }
            Row(
                modifier = Modifier
                    .position(Position.Absolute)
                    .right(0.px)
                    .top(50.percent)
                    .translateY((-50).percent),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.px)
            ) {
                if (isOpen) {
                    Box(
                        modifier = AccordionActionButtonBoxStyle.toModifier()
                            .border(1.px, LineStyle.Solid, Colors.Placeholder)
                            .borderRadius(7.px),
                        contentAlignment = Alignment.Center
                    ) {

                        FaChevronUp(
                            modifier = AccordionArrowIconStyle
                                .toModifier()
                                .cursor(Cursor.Pointer)
                                .color(Color.rgb(0xb5, 0xb5, 0xb5))
                        )
                    }
                } else {

                    Box(
                        contentAlignment = Alignment.Center,
                        modifier = AccordionPlusIconStyles.toModifier()
                            .borderRadius(50.percent)
                            .backgroundColor(Colors.White)
                            .border(1.5.px, LineStyle.Solid, Color.rgb(0xb5, 0xb5, 0xb5))

                    ) {
                        FaPlus(
                            modifier = AccordionPlusIconStyle.toModifier()
                                .color(Color.rgb(0xb5, 0xb5, 0xb5))
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun Headbar(
    cvViewModel: CvViewModel,
    modifier: Modifier = Modifier,
) {
    var colorMode by ColorMode.currentState
    var isEditingTitle by remember { mutableStateOf(false) }

    val isDark = colorMode.isDark
    val cvTitle = cvViewModel.cvTitle

    val navBg = if (isDark) {
        Colors.DarkBG
    } else {
        Colors.White
    }

    val textColor = if (isDark) {
        Colors.White
    } else {
        Colors.Primary
    }

    val iconFilter = if (isDark) {
        "none"
    } else {
        "invert(1)"
    }

    fun finishTitleEdition() {
        val finalTitle = cvViewModel.cvTitle
            .trim()
            .ifBlank { "Cv sans titre" }

        cvViewModel.updateCvTitle(finalTitle)
        isEditingTitle = false
    }

    Row(
        modifier = HeadbarContainerStyle
            .toModifier()
            .fillMaxWidth()
            .backgroundColor(navBg)
            .styleModifier {
                property("transition", "background-color 300ms ease")
                property("min-width", "0")
                property("box-sizing", "border-box")
            }
            .borderBottom(
                1.px,
                LineStyle.Solid,
                Colors.DarkGray
            )
            .then(modifier),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Link(
            path = Screen.CV.path,
            modifier = Modifier
                .textDecorationLine(
                    TextDecorationLine.None
                )
                .onClick {
                    window.history.back()
                }
        ) {
            Row(
                modifier = HeadbarBackButtonStyle
                    .toModifier()
                    .cursor(Cursor.Pointer)
                    .styleModifier {
                        property("flex-shrink", "0")
                    },
                verticalAlignment = Alignment.CenterVertically
            ) {

                Box(
                    contentAlignment = Alignment.Center,
                    modifier = Modifier
                        .size(24.px)
                        .borderRadius(50.percent)
                        .backgroundColor(Colors.White)
                        .border(1.px, LineStyle.Solid, Colors.Black)
                ) {
                    FaArrowLeft(
                        HeadbarIconSizeStyle.toModifier()
                            .color(Colors.Black)
                    )
                }

                SpanText(
                    text = "Retour",
                    modifier = HeadbarTextSizeStyle
                        .toModifier()
                        .margin(left = 10.px)
                        .fontFamily(INTER)
                        .color(textColor)
                )
            }
        }

        Spacer()

        Row(
            modifier = HeadbarTitleGroupStyle
                .toModifier()
                .styleModifier {
                    property("min-width", "0")
                    property("max-width", "100%")
                    property("flex", "1")
                    property("justify-content", "center")
                    property("overflow", "hidden")
                },
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (isEditingTitle) {
                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .then(HeadbarTitleInputStyle.toModifier())
                        .styleModifier {
                            property("width", "100%")
                            property("max-width", "300px")
                            property("min-width", "0")
                            property("box-sizing", "border-box")
                        }
                        .attrsModifier {
                            attr("value", cvTitle)
                            attr("autofocus", "true")
                            attr("aria-label", "Titre du CV")

                            addEventListener("input") { event ->
                                val input =
                                    event.target as? HTMLInputElement

                                input?.value?.let { value ->
                                    cvViewModel.updateCvTitle(value)
                                }
                            }

                            addEventListener("keydown") { event ->
                                when (event.asDynamic().key) {
                                    "Enter" -> finishTitleEdition()

                                    "Escape" -> {
                                        isEditingTitle = false
                                    }
                                }
                            }

                            addEventListener("blur") {
                                finishTitleEdition()
                            }
                        }
                        .toAttrs()
                )
            } else {
                SpanText(
                    text = cvTitle,
                    modifier = HeadbarTitleStyle
                        .toModifier()
                        .color(textColor)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Bold)
                        .cursor(Cursor.Text)
                        .styleModifier {
                            property("max-width", "100%")
                            property("min-width", "0")
                            property("overflow", "hidden")
                            property("text-overflow", "ellipsis")
                            property("white-space", "nowrap")
                        }
                        .onClick {
                            isEditingTitle = true
                        }
                )
            }

            Box(Modifier.width(10.px))


            FaCloudflare(
                modifier = HeadbarIconSizeStyle.toModifier()
                    .color(Colors.Black)
            )
        }

        Spacer()

        Box(
            modifier = HeadbarDownloadWrapperStyle
                .toModifier()
                .styleModifier {
                    property("flex-shrink", "0")
                }
        ) {
            DownloadCvButton(
                cvViewModel = cvViewModel,
                compact = true,
                showIcon = true,
                popupOpensDownward = true
            )
        }

        Row(
            modifier = HeadbarThemeToggleGroupStyle
                .toModifier()
                .styleModifier {
                    property("flex-shrink", "0")
                },
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (isDark) {
                FaSun(
                    modifier = HeadbarThemeIconSizeStyle
                        .toModifier()
                        .color(Colors.yellow)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            colorMode = colorMode.opposite
                        }
                )
            } else {
                FaMoon(
                    modifier = HeadbarThemeIconSizeStyle
                        .toModifier()
                        .color(Colors.Primary)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            colorMode = colorMode.opposite
                        }
                )
            }
        }
    }
}

@Composable
fun FormActionSection(
    activeExtraSections: List<ExtraSection>,
    cvViewModel: CvViewModel,
    onAddExtraSection: (ExtraSection) -> Unit,
    onOpenExtraSection: (ExtraSection) -> Unit,
    submitLabel: String = "",
    onCustomSubmit: (() -> Unit)? = null,
) {
    var personalizedSectionCounter by remember {
        mutableStateOf(
            activeExtraSections
                .mapNotNull { section ->
                    section.id
                        .removePrefix("rubrique-")
                        .toIntOrNull()
                }
                .maxOrNull() ?: 0
        )
    }

    Style {
        """
        @keyframes popUp {
            from { opacity: 0; transform: translateY(10px) scale(0.97); }
            to   { opacity: 1; transform: translateY(0)   scale(1);     }
        }
        """.trimIndent()
    }

    Column(
        modifier = FormActionSectionStyle
            .toModifier()
            .padding(top = 40.px)
    ) {
        Column(
            modifier = FormActionGridContainerStyle.toModifier(),
            verticalArrangement = Arrangement.spacedBy(10.px)
        ) {
            val availableSections = extraSectionsCatalog.filter { extra ->
                activeExtraSections.none {
                    it.id == extra.id
                }
            }

            ExtraSectionsGrid(
                availableSections = availableSections,
                onAddExtraSection = onAddExtraSection,
                onAddPersonalized = { type ->
                    val existingSection =
                        activeExtraSections.firstOrNull {
                            it.personalizedType == type
                        }

                    if (existingSection != null) {
                        onOpenExtraSection(existingSection)
                    } else {
                        personalizedSectionCounter++

                        val sectionId =
                            "rubrique-$personalizedSectionCounter"

                        val newSection = Section(
                            id = sectionId,
                            type = type,
                            title = defaultTitleFor(type),
                            resume = "",
                            started = "",
                            ended = "",
                            description = ""
                        )

                        cvViewModel.addPersonalizedSection(
                            newSection
                        )

                        val newExtraSection =
                            createPersonalizedSection(
                                type = type,
                                counter = personalizedSectionCounter,
                                cvViewModel = cvViewModel
                            )

                        onAddExtraSection(newExtraSection)
                    }
                }
            )
        }

        Box(
            Modifier.height(30.px)
        )

        Row(
            modifier = FormActionSubmitRowStyle
                .toModifier()
                .fillMaxWidth(),
            horizontalArrangement = Arrangement.End
        ) {
            if (onCustomSubmit != null) {
                FormSubmitButton(
                    label = submitLabel.ifBlank {
                        "Valider"
                    },
                    onClick = onCustomSubmit
                )
            } else {
                DownloadCvButton(
                    cvViewModel = cvViewModel
                )
            }
        }
    }
}

@Composable
private fun ExtraSectionsGrid(
    availableSections: List<ExtraSection>,
    onAddExtraSection: (ExtraSection) -> Unit,
    onAddPersonalized: (PersonalizedSectionType) -> Unit,
) {
    Row(
        modifier = ExtraSectionsGridStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        availableSections.forEach { extra ->
            InfoBox(
                text = extra.title,
                width = extra.collapsedWidth,
                onClick = {
                    onAddExtraSection(extra)
                }
            )
        }

        PersonalizedSectionButton(
            onClick = onAddPersonalized
        )
    }
}

@Composable
private fun FormSubmitButton(
    label: String,
    onClick: () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = ViewButtonStyle.toModifier()
            .then(FormActionButtonStyle.toModifier())
            .borderRadius(7.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Normal)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("white-space", "nowrap")
            }
    ) {
        SpanText(label)
    }
}